/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var FaceAHappyIcon20Light = forwardRef('FaceAHappyIcon20Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M13.922 11.051a.5.5 0 1 0-.966-.259 3.06 3.06 0 0 1-5.913 0 .5.5 0 1 0-.965.259 4.06 4.06 0 0 0 7.844 0Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2a8 8 0 1 0 0 16 8 8 0 0 0 0-16Zm-7 8a7 7 0 1 1 14 0 7 7 0 0 1-14 0Z" })));
});
